import { clx } from '@medusajs/ui';
import type { ReactNode } from 'react';

export const TextList = ({
  type,
  children,
}: {
  type: 'ul' | 'ol';
  children: ReactNode;
}) => {
  const Tag = type;
  return (
    <Tag
      className={clx('mt-2 list-inside', {
        'list-disc': type === 'ul',
        'list-decimal': type === 'ol',
      })}
    >
      {children}
    </Tag>
  );
};
